import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteNav } from '@/components/generals/site-nav'

/**
 * The page shell. It deliberately sets no background: the ambient window-light
 * sits behind the page at -z-10, and the body carries --surface.
 */
export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='relative flex min-h-screen flex-col text-ink'>
            <SiteNav />

            <main className='flex-1'>
                {children}
            </main>
        </div>
    )
}
